export const FB_API_VERSION = 'v16.0';
export const FB_ACCESS_TOKEN = 'EAAFMlTFQJ1oBAFIApXb5NOCxjLEVU0jKfSZBS1scESbh9hxMcifE4N7zDQIDlZAwZAkregg7ZC9mHv9ICnSSidyxbXZBTYlkvqZB9ZAFfc1pTK9mLHaDEDYX73ArX38i6Y5eRRVZBAVcoZAl8TKmYZBnYFezJ9hv2UyFFIILOE7yiuA5u2mrbAVIfvdhFA05mOTtoZD';
export const FB_PIXEL_ID = '1081316579035217';
